import React, { createContext, useState, useContext, useEffect } from 'react';

const appContext = createContext();

export const UserProvider = ({ children }) => {

  

  const [filters, setFilters] = useState({
    status: "",
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [CurrentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    console.log("********************************************** current page =  **********************************************" , CurrentPage) ; 
  } , [CurrentPage] ) ;  
  
  return (
    <appContext.Provider value={{searchQuery, setSearchQuery , filters, setFilters,CurrentPage, setCurrentPage}}>
      {children}
    </appContext.Provider>
  );
};

const useAppContext = () => useContext(appContext);
export {useAppContext} ;

